import { render, staticRenderFns } from "./NotesPopup.vue?vue&type=template&id=38c530e1&scoped=true"
import script from "./NotesPopup.vue?vue&type=script&lang=js"
export * from "./NotesPopup.vue?vue&type=script&lang=js"
import style0 from "./NotesPopup.vue?vue&type=style&index=0&id=38c530e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c530e1",
  null
  
)

export default component.exports